<template>
  <div class="content-box">
    <Loader v-if="loading" />
    <div class="full-chat-w" v-else>
      <div class="full-chat-i">
        <div class="full-chat-left scrollable">
          <div class="os-tabs-w os-tab">
            <ul class="nav nav-tabs upper centered">
              <li
                class="nav-item"
                v-for="tab in tabOptions"
                @click="changeTab(tab)"
                :key="tab.name"
              >
                <a
                  class="nav-link"
                  :class="{ active: selectedTab == tab.name }"
                >
                  <i :class="tab.icon"></i>
                  <span>{{ tab.name }}</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="tab-container">
            <!-- <div v-show="selectedTab == 'Queue'"> -->
            <div class="ae-list-w">
              <div class="ael-head">
                <div class="actions-left">
                  <h5>{{ pendingProducts.length }} Products</h5>
                  <!-- <div class="input-search-w"><input class="form-control rounded bright" @input="isTyping = true" v-model="searchString"  placeholder="Type to filter..." type="search"></div> -->
                </div>
                <div class="actions-right">
                  <div class="btn-group">
                    <button
                      aria-expanded="false"
                      aria-haspopup="true"
                      class="btn dropdown-toggle"
                      data-toggle="dropdown"
                      type="button"
                      style="padding-left: 0; background: #f2f4f8"
                      v-if="lockedProducts.length == 0"
                    >
                      <h6 class="dispatch-location">Bulk Action</h6>
                    </button>
                    <div
                      aria-labelledby="export-button"
                      class="dropdown-menu"
                      x-placement="top-start"
                    >
                      <a
                        class="dropdown-item"
                        @click="actionPendingProductBulk(1)"
                        >Approve All</a
                      >
                      <a
                        class="dropdown-item"
                        @click="actionPendingProductBulk(0)"
                        >Reject All</a
                      >
                    </div>
                  </div>

                  <a @click="refreshProductRail">
                    <i class="os-icon os-icon-grid-18"></i>
                  </a>
                </div>
              </div>
              <div class="ae-list">
                <Loader v-if="loadingPendingRail" />
                <ProductRail
                  v-else
                  :lockedProducts="lockedProducts"
                  :products="pendingProducts"
                  :selectedProduct="selectedProduct"
                  @productRailInterface="updateSelectedProduct"
                />
              </div>
            </div>
            
            <!-- </div> -->
          </div>
        </div>

        <div class="full-chat-middle">
          <div class="chat-head">
            <div class="user-info">
              <button
                class="mr-2 mb-2 btn btn-success btn-sm large-button"
                type="button"
                @click="updateFinalImages"
                v-if="updateRequired == true"
              >
                Update Images
              </button>
              <div 
                v-if="(selectedProduct.lock && selectedProduct.lock.id_user != user)"
              >
                This product is locked by {{selectedProduct.lock.name}}
              </div>
              <div
                v-else-if="
                  loadingImages == false &&
                  waitingForAction == false &&
                  updateRequired == false &&
                  showActions == true
                "
              >
                <button
                  class="mr-2 mb-2 btn btn-success btn-sm"
                  type="button"
                  @click="actionPendingProduct(1)"
                >
                  Approve
                </button>
                <button
                  class="mr-2 mb-2 btn btn-danger btn-sm"
                  type="button"
                  @click="actionPendingProduct(0)"
                >
                  Reject
                </button>

              </div>
            </div>
            <div class="user-actions">

              <a>
                <i
                  class="fas fa-spinner fa-spin"
                  v-if="resequencingImages == 'pending'"
                ></i>
                <i
                  class="fas qc-1 fa-check"
                  v-if="resequencingImages == 'done'"
                ></i>
              </a>
                <button
                v-show="
                  loadingImages == false &&
                  waitingForAction == false &&
                  updateRequired == false &&
                  showActions == true
                "
                  class="mr-2 mb-2 btn btn-primary btn-sm "
                  type="button"
                  @click="showComments = !showComments"
                >
                  {{showComments ? 'Product Details': 'Comments'}}
                </button>
            </div>
          </div>
          <div
            class="chat-head"
            v-if="
              pretouchPath &&
              pretouchPath.hasOwnProperty('path')
            "
          >
            <span class="h6"
              >If Approved, this product will be dispatched to

                <div style="display: inline;">
                    <a
                      aria-expanded="false"
                      aria-haspopup="true"
                      class="btn btn-white pt-0"
                      data-toggle="dropdown"
                      type="button"
                      style="padding: 2px 10px 2px 2px; font-size: 15px; border: 0px;margin-top: -3px;"
   
                    >
                      <span class="text-primary text-bold" style="font-size: 1rem;">
                        {{selectedProduct.retouch_agency_name}}
                      </span>
                    </a>

                    <div
                      aria-labelledby="export-button"
                      class="dropdown-menu"
                      x-placement="top-start"
                    >
                      <a
                        class="dropdown-item"
                        v-for="agency in retouchAgencies"
                        @click="updateRetouchAgency(agency.id_retouch_agency)"
                        >{{ agency.name }}</a
                      >
                    </div>
                  </div>

              Retoucher at
              <span>
                <div class="inherit">
                  <div
                    v-for="(value, path_index) in pretouchPath.path"
                    class="inherit"
                  >
                    <a
                      aria-expanded="false"
                      aria-haspopup="true"
                      class="btn btn-white pt-0"
                      data-toggle="dropdown"
                      type="button"
                      style="padding: 2px; font-size: 15px; border: 0px; padding-right: 10px;"
                      v-if="value.editable == true"
                    >
                      <span class="text-primary text-bold">{{
                        value.selected_value
                      }}</span>
                    </a>
                    <span class="text-bold" style="padding: 5px; font-size: 15px; "
                    v-else>{{
                      value.selected_value
                    }}</span>
                    <div
                      aria-labelledby="export-button"
                      class="dropdown-menu"
                      x-placement="top-start"
                    >
                      <a
                        class="dropdown-item"
                        v-for="val in value.possible_values"
                        @click="overridePretouchPath(path_index, val)"
                        >{{ val }}</a
                      >
                    </div>
                    <div class="inherit forward-slash">/</div>
                  </div>
                  <button
                    v-if="pretouchPathPendingUpdate"
                    class="ml-2 btn btn-success btn-sm"
                    type="button"
                     @click="updatePretouchPath(pretouchPathUpdated)"
                  >
                    Update Pretouch 
                  </button>
                </div>
              </span>
            </span>
          </div>
          <div class="chat-content-w">
            <EmptyState v-if="waitingForAction">
              <div slot="empty_state_text" v-if="pendingProducts.length > 0">
                Select a product to continue
              </div>
              <div slot="empty_state_text" v-else>
                There are no products in queue
              </div>
            </EmptyState>
            <div v-else>
              <Loader v-if="loadingImages" />
              <Workspace
                :product="selectedProduct"
                :final-images="finalImages"
                :images="images"
                @resequenceInterface="resequenceImages"
                @deleteInterface="markDelete"
                v-else
              />
            </div>
          </div>
          <div class="chat-controls" v-if="!waitingForAction">
            <div class="chat-input">
              <textarea
                class="form-group form-control"
                placeholder="Type your comment..."
                type="text"
                contenteditable
                v-model="productComment"
              />
            </div>
            <div class="chat-input-extra">
              <div class="chat-extra-actions">
                <a>
                  <i class="os-icon os-icon-mail-07"></i>
                </a>
              </div>
              <div class="chat-btn">
                <a class="btn btn-primary btn-sm" @click="addProductComment"
                  >Add Comment</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="full-chat-right scrollable">
          <EmptyState v-if="waitingForAction || loadingProduct">
            <div slot="empty_state_text">..</div>
          </EmptyState>
          <div v-else>
            <ProductInfoBlock
              :type="'pretouchdesk'"
              :selectedProduct="selectedProduct"
              :finalImages="finalImages"
              :pendingRefresh="pendingRefresh"
              @refreshInterface="pendingRefresh = 1"
              v-if="!showComments"
            />
            <CommentRail :comments="productComments" v-else/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/common/Loader";
import Placeholder from "@/components/common/Placeholder";
import EmptyState from "@/components/common/EmptyState";
import Workspace from "@/components/photodesk/Workspace";
import ProductRail from "@/components/common/SessionAdd/ProductRail";
import CommentRail from "@/components/common/SessionAdd/CommentRail";
import ProductInfoBlock from "@/components/common/SessionAdd/ProductInfoBlock";

import Session from "@/mixins/session";
import Product from "@/mixins/product";
import Image from "@/mixins/image";

import At from "vue-at";
import AtTa from "vue-at/dist/vue-at-textarea";
import { debounce } from "underscore";
import DnD from "@/mixins/dragdrop.js";

export default {
  name: "session-view",
  mixins: [Session, Image, Product, DnD],
  components: {
    Loader,
    EmptyState,
    Workspace,
    ProductRail,
    CommentRail,
    ProductInfoBlock,
    Placeholder,
    At,
    AtTa,
  },
  props: ["id_session"],
  data: function () {
    return {
      tabOptions: [
        {
          name: "Queue",
          icon: "fal fa-image",
        },
        {
          name: "Dispatch Held",
          icon: "fa fa-pause",
        },
      ],
      showComments: false,
      showActions: true,
      selectedTab: "Queue",
      session: "",
      pendingProducts: [],
      selectedProduct: "",
      images: [],
      finalImages: [],
      allocatedImages: [],
      productComment: "",
      loading: true,
      loadingImages: false,
      loadingProduct: false,
      loadingPendingRail: true,
      waitingForAction: true,
      resequencingImages: "",
      pendingRefresh: 0,
      retouchAgencies: [],
      pretouchPath: "",
      pretouchPathPendingUpdate: false,
      pretouchPathUpdated: "",
      retouchAgencies: [],
      productComments: '',
      lockedProducts: []
    };
  },
  mounted: function () {
    var self = this;
    this.getSessionDetails();

    var product_channel = this.$pusher.subscribe("product");
    product_channel.bind("cacheupdated", function (data) {
      console.log(data)
      if (parseInt(data.id_product) == parseInt(self.selectedProduct.id_product)) {
        self.updateProduct();
      }
    });

    product_channel.bind("lock", function (data) {
      console.log(data)
      let obj = self.pendingProducts.find((o, i) => {
          if (o.id_product === data.id_product && data.lock_status == 1) {
              o.lock_id_user = data.id_user
              o.lock_avatar = data.avatar
              return true; // stop searching
          }
          if (o.id_product === data.id_product && data.lock_status == 0) {
              o.lock_id_user = null
              o.lock_avatar = null
              o.lock_user_name = null
              return true; // stop searching
          }
      });
    });

  },
  methods: {
    getSessionDetails: function () {
      var self = this;
      var search =
        this.searchString != "" ? "&search=" + this.searchString : "";
      const url = "/pretouchdesk/sessions/view";
      let data = {
        id_pretouchdesk_session: self.id_session,
      };
      self.loading = true;
      this.$http
        .post(url, data, {
          dataType: "json",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          self.session = response.data;
          self.getPendingProducts();
          self.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          self.$store.dispatch("updateToast", {
            text: error.response,
            show: true,
          });
          self.loading = false;
        });
    },
    getPendingProducts: function () {
      console.log("here");
      var self = this;
      var search =
        this.searchString != "" ? "&search=" + this.searchString : "";
      const url = "/pretouchdesk/sessions/products/pending";
      let data = {
        id_pretouchdesk_session: self.session.id_pretouchdesk_session,
      };
      self.loadingPendingRail = true;
      this.$http
        .post(url, data, {
          dataType: "json",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          self.pendingProducts = response.data;
          self.loadingPendingRail = false;
        })
        .catch(function (error) {
          // add toast message
          self.$store.dispatch("updateToast", {
            text: error.response,
            show: true,
          });
          self.loadingPendingRail = false;
        });
    },
    getPendingDispatchProducts: function () {
      console.log("here");
      var self = this;
      var search =
        this.searchString != "" ? "&search=" + this.searchString : "";
      const url = "/pretouchdesk/sessions/products/pendingdispatch";
      let data = {
        id_pretouchdesk_session: self.session.id_pretouchdesk_session,
      };
      self.loadingPendingRail = true;
      this.$http
        .post(url, data, {
          dataType: "json",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          self.pendingProducts = response.data;
          self.loadingPendingRail = false;
        })
        .catch(function (error) {
          // add toast message
          self.$store.dispatch("updateToast", {
            text: error.response,
            show: true,
          });
          self.loadingPendingRail = false;
        });
    },
    markDelete: function (data) {
      var self = this;
      var image = data;

      if (image.is_marked_delete && image.is_marked_delete == 1) {
        if (self.updateImagesSet) {
          var newSet = remove(self.updateImagesSet, function (item) {
            return item.id_product_image === parseInt(image.id_product_image);
          });
          self.$store.dispatch("updateimagesUpdateSet", self.updateImagesSet);
          if (self.updateImagesSet == 0) {
            self.$store.dispatch("updateimagesUpdateRequired", false);
          }
        }
        image.is_marked_delete = 0;
        return true;
      }

      if (self.updateImagesSet) {
        self.updateImagesSet.push({
          id_product_image: image.id_product_image,
          id_image: null,
        });
      }
      self.$set(image, "is_marked_delete", 1);
      self.$store.dispatch("updateimagesUpdateRequired", true);
      self.$store.dispatch("updateimagesUpdateSet", self.updateImagesSet);
      console.log(self.updateImagesSet);
    },
    getFinalSequence: function () {
      var self = this;
      const url = "/imagedesk/image/final";
      let data = {
        id_product: self.selectedProduct.id_product,
      };

      self.loadingImages = true;
      this.$http
        .post(url, data, {
          dataType: "json",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          self.finalImages = response.data.final_images;
          self.loadingImages = false;
          self.doRefresh = true;
        })
        .catch(function (error) {
          console.log(error);
          self.$store.dispatch("updateToast", {
            text: error.response.data.message,
            show: true,
          });
          self.loadingImages = false;
        });
    },
    actionPendingProductBulk: function (action) {
      const actionText = action == 1 ? "approve " : "reject ";
      const productsLength = this.pendingProducts.length;
      if (
        !confirm(
          "Are you sure you want to " +
            actionText +
            productsLength +
            " products?"
        )
      ) {
        return;
      }
      var self = this;
      const url = "/pretouchdesk/sessions/products/add";

      let id_products = self.pendingProducts.map(function (
        product,
        index,
        array
      ) {
        return product.id_product;
      });

      let data = {
        id_pretouchdesk_session: self.session.id_pretouchdesk_session,
        id_product: id_products.toString(),
        is_approve: action,
      };
      this.$http
        .post(url, data, {
          dataType: "json",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          if (action == 1) {
            self.$store.dispatch("updateToast", {
              text: productsLength + " Products Approved",
              show: true,
            });
          } else {
            self.$store.dispatch("updateToast", {
              text: productsLength + " Products Rejected",
              show: true,
            });
          }
          self.refreshProductRail();
        })
        .catch(function (error) {
          console.log(error);
          self.$store.dispatch("updateToast", {
            text: error.response,
            show: true,
          });
          self.loadingPendingRail = false;
        });
    },
    actionPendingProduct: function (action) {

      var self = this;
      const url = "/pretouchdesk/sessions/products/add";
      const id_products = [];

      id_products.push(self.selectedProduct.id_product);

      let data = {
        id_pretouchdesk_session: self.session.id_pretouchdesk_session,
        id_product: id_products.toString(),
        is_approve: action,
      };
      this.$http
        .post(url, data, {
          dataType: "json",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          if (action == 1) {
            self.$store.dispatch("updateToast", {
              text: "Product Approved",
              show: true,
            });
          } else {
            self.$store.dispatch("updateToast", {
              text: "Product Rejected",
              show: true,
            });
          }
          self.loadNextProduct();
        })
        .catch(function (error) {
          console.log(error);
          self.$store.dispatch("updateToast", {
            text: error.response,
            show: true,
          });
          self.loadingPendingRail = false;
        });
    },
    loadNextProduct: function () {
      var self = this;
      var current_ix = self.selectedProduct.id_photodesk_product
      
      var next_product = current_ix

      self.pendingProducts.find((o, i) => {
        if (o.id_photodesk_product > current_ix) {
          next_product = i
          return true;
        }
      });

      self.pendingProducts.find((o, i) => {
        if (o.id_product == self.selectedProduct.id_product) {
          self.pendingProducts.splice(i, 1);
          return true;
        }
      });
      if (self.pendingProducts.length > 0) {
        self.selectedProduct = this.pendingProducts[next_product - 1];
        self.waitingForAction = true;
        self.updateSelectedProduct(self.selectedProduct);
      } else {
        self.selectedProduct = "";
        self.waitingForAction = true;
      }
    },
    refreshProductRail: function () {
      if (this.selectedTab == "Queue") {
        this.showActions = true;
        this.getPendingProducts();
      }
      if (this.selectedTab == "Dispatch Held") {
        this.showActions = false;
        this.getPendingDispatchProducts();
      }
      this.lockedProducts = []
      this.selectedProduct = "";
      this.waitingForAction = true;
    },
    updateSelectedProduct: function (data) {
      this.selectedProduct = data;
      this.getProduct('pretouch');
      this.getProductComments();
      this.waitingForAction = false;
    },
    resequenceImages: function (data) {
      var self = this;
      if (data == "start") {
        self.resequencingImages = "pending";
      } else {
        self.resequencingImages = "done";
        setTimeout(function () {
          self.resequencingImages = "";
        }, 2000);
      }
    },
    addProductComment: function () {
      var self = this;
      const url = "/productdesk/product/comment/add";
      let data = {
        id_product: self.selectedProduct.id_product,
        comment: self.productComment,
      };

      this.$http
        .post(url, data, {
          dataType: "json",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          self.productComment = "";
          self.getProductComments();
          console.log(response);
        })
        .catch(function (error) {});
    },
    changeTab: function (tab) {
      this.selectedProduct = "";
      this.waitingForAction = true;
      this.selectedTab = tab.name;
      if (tab.name == "Queue") {
        this.showActions = true;
        this.getPendingProducts();
      }
      if (tab.name == "Dispatch Held") {
        this.showActions = false;
        this.getPendingDispatchProducts();
      }
    },
    overridePretouchPath(path_index, path) {
      this.pretouchPath.path[path_index]['selected_value'] = path;
      this.pretouchPath.path[path_index]['is_edited'] = true;

      var updatedPath = []
      this.pretouchPath.path.forEach(function (c) {
        if(c.hasOwnProperty('is_edited')) {
          updatedPath.push(`{'${c.selected_value}'}`)
        } else {
          updatedPath.push(`{${c.name}}`)
        }
      })
      this.pretouchPathUpdated = updatedPath.join(":")

      this.pretouchPathPendingUpdate = true
    },
  },
  watch: {
    selectedProduct: function (val) {
      this.getRetouchAgencies()
      this.pretouchPath = this.selectedProduct.pretouch_path
      this.pretouchPathPendingUpdate = false
    },
  },
  computed: {
    user() {
      return this.$store.getters.authUser.id_user
    },
    clientUsers() {
      return this.$store.getters.clientUsers;
    },
    updateRequired() {
      return this.$store.getters.updateRequired;
    },
    searchString: debounce(function () {
      this.isTyping = false;
    }, 1000),
    isTyping: function (value) {
      if (!value) {
        this.getSessionDetails();
      }
    },
  },
};
</script>

<style scoped>
.qc-1 {
  color: #75da62 !important;
}

.qc-0 {
  color: #da6262 !important;
}

.flagged {
  color: #ffc107 !important;
}
.ae-list-w {
  background-color: #f2f4f8;
}
.element-wrapper .element-search input {
  background-color: #fff;
  border-radius: 0px !important;
}

.full-chat-w .full-chat-left {
  padding: 0px !important;
}

.element-wrapper {
  padding-bottom: 0rem !important;
}

.os-tab {
  position: absolute;
  top: 0;
  width: 340px;
  background: #f2f4f8;
  z-index: 999;
}

.tab-container {
  margin-top: 53px;
}
.dispatch-location {
  padding-top: 6px;
}
.inherit {
  display: inherit;
}
.forward-slash {
  line-height: 35px;
  padding-right: 5px;
  font-weight: bold;
}
.full-chat-w .chat-content-w {
  height: calc(100vh - 275px) !important;
  overflow-y: scroll;
  position: relative;
}
</style>
